import React from 'react';
import PropTypes from 'prop-types';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import ExportPictureButton from './ExportPictureButton';
import CardFrame from './CardFrame';

function CardFrontEdit({ cardFrame, cardArtElement, replacements, cardTextElement, id }) {
    const { cardFrontRef } = useFormTab();

    return (
        <>
            <CardFrame
                id={id}
                cardFrame={cardFrame}
                replacements={replacements}
            >
                {cardArtElement}
                {cardTextElement}
            </CardFrame>
            <figcaption>Card Frame + Card Art</figcaption>
            <ExportPictureButton cardFrontRef={cardFrontRef} />
        </>
    );
}

CardFrontEdit.defaultProps = {
    cardFrame: '',
    replacements: [],
};

CardFrontEdit.propTypes = {
    cardFrame: PropTypes.string,
    cardArtElement: PropTypes.node.isRequired,
    cardTextElement: PropTypes.node.isRequired,
    replacements: PropTypes.array,
    id: PropTypes.string.isRequired,
};
export default React.memo(CardFrontEdit);
